<template>
    <div class="h-full">
        <ai-grid-edit v-if="isDataLoaded" ref="gridRef" :meta="meta" :args="args" />
    </div>
</template>

<script setup>
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { onMounted, ref, reactive, computed } from 'vue';
import { useRoute } from 'vue-router';
import { getOkved } from '@/service/counteragent-service';

//import { getOkvedRazdel, getOkveds } from '@/service/counteragent-service';

const gridRef = ref();

const isDataLoaded = ref(false);
/*const razdel = ref([]);
const razdelComp = computed(() => razdel.value);*/
/*const okved = ref([]);
const okvedComp = computed(() => okved.value);*/
const refreshDicts = async () => {
    /*const data = await getOkvedRazdel();
    if (data && data.result) {
        razdel.value = data.data;
    }*/
    /*const data2 = await getOkveds();
    if (data2 && data2.result) {
        okved.value = data2.data;
    }*/
    state.okvedList = await getOkved();
};

onMounted(async () => {
    await refreshDicts();
    isDataLoaded.value = true;
});

const route = useRoute();

const state = reactive({
    okvedList: [],
});

const meta = reactive({
    keyExpr: 'id',
    viewId: 'WidgetPayerDopOkved',
    focusedRowEnabled: true,
    api: {
        select: 'counteragent./customer/card/widget/dop-okved/get',
        //save: 'counteragent./customer/card/widget/notebook/save'
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        {
            dataField: 'okved',
            caption: 'ОКВЭД',
            dataType: 'string',
            width: 150,
            allowEditing: false,
        },
        {
            dataField: 'kod_okved',
            caption: 'Наименование ОКВЭД',
            width: 200,
            dataType: 'number',
            editor: { type: 'ai-popup', text: 'ename' },
            component: {
                id: 'kod_okved',
                text: 'name',
                path: 'components/dictionary-components/ai-dictionary-tree-list.vue',
                keyExpr: 'kod_okved',
                parentIdExpr: '',
                dataSource: displayOkvedList,
            },
        },
    ],
});

const args = { select: { kodp: route.params.id }, save: { kodp: route.params.id } };

const displayOkvedList = computed(() => state.okvedList.filter(o => o.kod_res_okved === 1));
</script>
